import { render, staticRenderFns } from "./SACFilters.vue?vue&type=template&id=4b9b2fa0"
import script from "./SACFilters.vue?vue&type=script&lang=js"
export * from "./SACFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports